import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import SingleCustomerSelector from '../selectors/customer/SingleCustomerSelector'
import AUTHENTICATION_API from '../../controllers/authentication';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const FORM_NAME = 'SUPPORT_LOGIN_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/; // From http://emailregex.com/
class SupportLoginForm extends Component {
    constructor(props) {
        super(props);
        this.handleChangeAccount = this.handleChangeAccount.bind(this);

    }
    render() {
        log.debug('render: ', this.props, sessionStorage.token);

        const fieldValues = this.props.formData && this.props.formData.fieldValues;

        //TO DO Replace localStorage
        if (sessionStorage.token !== undefined && this.props.masqueradeSuccess === true)
            return (<Redirect to="/dashboard" />);

        return (
            <main>
                <s-container class="max-width">
                    <s-row>
                        <s-col span="sm-10 md-8 lg-6 4" offset="sm-2 md-4 lg-6 8">
                            <s-box class="pad-all-lg" name="login-panel">
                                <form className="form" onSubmit={this.onSubmit.bind(this)}>
                                    <fieldset>
                                        <h2 className="alt"><LanguageStringResolver string='LogInTitle'></LanguageStringResolver></h2>
                                        <h3 className="alt"><LanguageStringResolver string='LogInHelpText'></LanguageStringResolver></h3>

                                        <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationWarning" />
                                        <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError" />
                                        <HighlightOnInAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.INVALID_USERNAME]}
                                        >
                                            <div className="form__field-wrapper input-container mb20">

                                                <label className="form__field-label" htmlFor="username"><LanguageStringResolver string='UsernameLabel' /></label>
                                                <input
                                                    className="form__field-input"
                                                    type="text"
                                                    value={(fieldValues && fieldValues.username) || ''}
                                                    onChange={this.onFieldChangeHandlerFactory('username').bind(this)}
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    spellCheck="false"
                                                />
                                            </div>
                                        </HighlightOnInAppMessage>
                                        <HighlightOnInAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.BLANK_PASSWORD]}
                                        >
                                            <div className="form__field-wrapper input-container mb20">
                                                <label className="form__field-label" htmlFor="password"><LanguageStringResolver string='PasswordLabel' /></label>
                                                <input
                                                    className={withFullStoryExclude("form__field-input")}
                                                    type="password"
                                                    value={(fieldValues && fieldValues.password) || ''}
                                                    placeholder="••••••••••"
                                                    onChange={this.onFieldChangeHandlerFactory('password').bind(this)}
                                                />
                                            </div>
                                        </HighlightOnInAppMessage>
                                        <HighlightOnInAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.BLANK_ACCOUNTID]}
                                        >
                                            <div className="form__field-wrapper input-container mb20">

                                                <label className="form__field-label" htmlFor="accountId"><LanguageStringResolver string='supportingLogin_AccountId' /></label>
                                                <SingleCustomerSelector
                                                    fieldName={"accountId"}
                                                    selectionHandler={this.handleChangeAccount}
                                                    selectedCustomerId={(fieldValues && fieldValues.accountId) || ''}
                                                    customerList={this.props.customers || []}
                                                />
                                            </div>
                                        </HighlightOnInAppMessage>
                                        <HighlightOnInAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.BLANK_LICENSEKEY]}
                                        >
                                            <div className="form__field-wrapper input-container mb20">

                                                <label className="form__field-label" htmlFor="licenseKey"><LanguageStringResolver string='supportingLogin_LicenseKey' /></label>
                                                <input
                                                    className="form__field-input"
                                                    type="text"
                                                    value={(fieldValues && fieldValues.licenseKey) || ''}
                                                    onChange={this.onFieldChangeHandlerFactory('licenseKey').bind(this)}
                                                />
                                            </div>
                                        </HighlightOnInAppMessage>
                                        <div className="form__submit-btn-wrapper">
                                            <button className="primary large mb20" type="submit"><LanguageStringResolver string='LogInButton' /></button>
                                        </div>
                                    </fieldset>
                                </form>
                            </s-box>
                            <div className="clear"></div>
                        </s-col>
                    </s-row>
                </s-container>
            </main>
        );
    }
    UNSAFE_componentWillMount() {
        this.props.onPageLoad();
        log.debug('componentWillMount(): ', this.props);
        log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
        log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_ACCOUNTID);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_LICENSEKEY);
        this.props.doInitialiseForm({ username: '', password: '', accountId: '', licenseKey: '', isAuthenticated: false, errorMessage: null });
        // this.props.doInitialiseForm(this.props.userLogin);

    }
    componentWillUnmount() {
        log.debug('componentWillUnmount(): ', this.props);
        this.props.doDestroyForm(FORM_NAME);
    }
    onFieldChangeHandlerFactory(fieldName) {
        return (evt) => {
            log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
            log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
            log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
            log.clearDictionaryError(ALL_MESSAGES.BLANK_LICENSEKEY);
            log.clearDictionaryError(ALL_MESSAGES.INVALID_MASQUERADE_CREDENTIALS);
            this.props.onFieldChange(fieldName, evt.target.value)
        }
    }

    handleChangeAccount(keyValuePairs) {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_ACCOUNTID);

        var value = ''
        for (var i in keyValuePairs) {
            value = keyValuePairs[i];
        }

        this.props.onFieldChange('accountId', value)

    }

    // onSubmit call the passed onSubmit function
    onSubmit(evt) {
        log.debug('onSubmit(): clearing errors', ALL_MESSAGES.INVALID_USERNAME, ALL_MESSAGES.BLANK_PASSWORD, ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);

        log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
        log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_ACCOUNTID);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_LICENSEKEY);
        let fieldsOk = true;
        evt.preventDefault();
        const username = this.props.formData.fieldValues.username.trim();
        const password = this.props.formData.fieldValues.password.trim();
        const accountId = this.props.formData.fieldValues.accountId.trim();
        const licenseKey = this.props.formData.fieldValues.licenseKey.trim();

        if (!EMAIL_REGEX.test(username)) {
            log.setDictionaryMessage(ALL_MESSAGES.INVALID_USERNAME);
            fieldsOk = false;
        }
        if (password === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_PASSWORD);
            fieldsOk = false;
        }
        if (accountId === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_ACCOUNTID);
            fieldsOk = false;
        }
        if (licenseKey === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_LICENSEKEY);
            fieldsOk = false;
        }

        if (!fieldsOk) {
            return;
        }

        this.props.doAttemptMasquerade(username, password, accountId, licenseKey, (authInfo) => {
            log.debug('onSubmit().onAttemptLogin: success: ', authInfo);
            this.props.onSuccessHandler(authInfo)
        }, (error) => {
            log.debug('onSubmit().onAttemptLogin: error: ', error, error.status);
            if (error.status > 499)
                log.setDictionaryMessage(ALL_MESSAGES.CONNECTION_ERROR);
            else if (error.status === 401)
                log.setDictionaryMessage(ALL_MESSAGES.INVALID_MASQUERADE_CREDENTIALS);
            this.props.onFailHandler(error);
        });
    }
}




function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): ', state);
    log.debug('mapStateToProps(): props', props);

    return {
        formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
        customers: state.authentication && state.authentication.customer,
        masqueradeSuccess: state.authentication && state.authentication.masqueradeSuccess
    };
}

function mapDispatchersToProps(dispatch) {
    return {
        onPageLoad: () => {
            log.debug('onPageLoad: ');
            dispatch(AUTHENTICATION_API.doGetCustomers());
        },
        doInitialiseForm: (initialValues) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
        },
        doResetForm: () => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
        },
        doClearForm: () => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
        },
        onFieldChange: (fieldName, value) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
        },
        doFormSubmitted: (fieldName, value) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
        },
        doDestroyForm: () => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
        },

        doAttemptMasquerade: (username, password, accountId, licenseKey, successHandler, failureHandler) => {
            log.debug('onAttemptLogin:');
            dispatch(AUTHENTICATION_API.doAttemptLogin(username, password, (authInfo) => {
                log.debug('onAttemptLogin: success login', authInfo);
                dispatch(AUTHENTICATION_API.doAttemptMasquerade(accountId, licenseKey, response => {
                    log.debug('doAttemptMasquerade: success', authInfo);
                    log.clearDictionaryError(ALL_MESSAGES.INVALID_MASQUERADE_CREDENTIALS);
                    log.clearDictionaryError(ALL_MESSAGES.CONNECTION_ERROR);
                    successHandler(authInfo);
                }, (error) => {
                    log.debug('doAttemptMasquerade: failure', error);
                    failureHandler(error);

                }));
            }, (error) => {
                log.debug('onAttemptLogin: failure', error);
                failureHandler(error);

            }));
        },
    };
}
export default connect(mapStateToProps, mapDispatchersToProps)(SupportLoginForm);
